export default __webpack_public_path__ + "static/ico-sciezki-7fb5758f6b390c1f043fe0ef9d119170.svg";